import { AutocompleteAdapter } from 'components/form/AutocompleteAdapter';
import { MultipleAutocompleteAdapter } from 'components/form/MultipleAutocompleteAdapter';
import ReactFinalForm from 'components/form/ReactFinalForm';
import { TextFieldAdapter } from 'components/form/TextFieldAdapter';
import { required } from 'helpers/validators';
import { IOperationalUnit, IOption } from 'interfaces';
import { useEffect, useState } from 'react';
import { IdentityField } from 'components/form/IdentityField';
import { useTranslation } from 'react-i18next';
import { productService, laboratoryService } from 'services/api';

interface FormParams {
  operational_unit: IOperationalUnit;
  onSubmit: any;
  disableEdit?: boolean;
}
function OperationalUnitForm(params: FormParams) {
  const { t } = useTranslation();

  const [laboratories, setLaboratories] = useState<IOption[]>([]);
  const [products, setProducts] = useState<IOption[]>([]);

  useEffect(() => {
    laboratoryService.getAllBaseInformation().then(setLaboratories);
    productService.getAllBaseInformation().then(setProducts);
  }, []);

  const { operational_unit, onSubmit, disableEdit } = params;
  return (
    <div>
      {operational_unit && (
        <ReactFinalForm
          onSubmit={disableEdit ? {} : onSubmit}
          disableEdit={disableEdit}
          edit={!!operational_unit.id}>
          <div className="flex flex-wrap">
            <div className="w-full md:w-1/3 pr-4">
              <IdentityField
                name="code"
                initialValue={operational_unit.code}
                component={TextFieldAdapter}
                label={t('global.code')}
                type="text"
                validate={required}
                disabled={disableEdit}
              />
            </div>
            <div className="w-full md:w-2/3">
              <IdentityField
                name="description"
                initialValue={operational_unit.description}
                component={TextFieldAdapter}
                label={t('global.description')}
                type="text"
                validate={required}
                disabled={disableEdit}
              />
            </div>

            <div className="w-full my-4">
              {laboratories && (
                <IdentityField
                  name="laboratory"
                  component={AutocompleteAdapter}
                  initValue={laboratories.find((s) => s.id === operational_unit.laboratory)}
                  defaultValue={operational_unit.laboratory}
                  options={laboratories}
                  label={t('global.laboratory')}
                  type="text"
                  disabled={disableEdit}
                />
              )}
            </div>
            <div className="p-2 w-full">
              <IdentityField
                name="products"
                component={MultipleAutocompleteAdapter}
                options={products}
                initValue={operational_unit.products}
                label={t('global.products')}
                type="text"
                disabled={disableEdit}
              />
            </div>
          </div>
        </ReactFinalForm>
      )}
    </div>
  );
}

export default OperationalUnitForm;
